import { createElement } from '@wordpress/element';
import { registerFormatType, applyFormat, removeFormat, getActiveFormat } from '@wordpress/rich-text';
import { InspectorControls, PanelColorSettings } from '@wordpress/block-editor';
import commonVars from '../common.scss';

function Color() {
    [
        {
            name: 'color',
            title: 'Couleur du texte',
        },
    ].forEach(({ name, title }) => {
        const type = `advanced/${name}`;

        registerFormatType(type, {
            title,
            tagName: 'span',
            className: name,
            attributes: {
                style: 'style',
            },
            edit({ isActive, value, onChange }) {
                let activeColor;

                if (isActive) {
                    const activeFormat = getActiveFormat(value, type);
                    const style = activeFormat.attributes.style;

                    activeColor = style.replace(new RegExp(`^${name}:\\s*`), '');
                }

                return createElement(
                    InspectorControls,
                    null,
                    createElement(PanelColorSettings, {
                        title,
                        initialOpen: true,
                        colorSettings: [
                            {
                                value: activeColor,
                                onChange: (color) => {
                                    if (color) {
                                        onChange(
                                            applyFormat(value, {
                                                type,
                                                attributes: {
                                                    style: `${name}:${color}`,
                                                },
                                            }),
                                        );
                                        return;
                                    }

                                    onChange(removeFormat(value, type));
                                },
                                label: 'Appliquer une couleur au texte sélectionné',
                                colors: [
                                    { name: 'orange', color: commonVars.orange },
                                    { name: 'black', color: commonVars.black },
                                    { name: 'dark', color: commonVars.dark },
                                    { name: 'grey', color: commonVars.grey },
                                    { name: 'clay', color: commonVars.clay },
                                ],
                            },
                        ],
                    }),
                );
            },
        });
    });
}

export default Color;
